import { useState } from "react";
import {
  Container,
  Card,
  Form,
  Button,
  Alert,
  Spinner,
} from "react-bootstrap";
import { loadStripe } from "@stripe/stripe-js";
import {
  Elements,
  PaymentElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";

const stripePromise = loadStripe(
  "pk_test_51QtMoYJyF40wM9B0Se1fgklXHRop2iczcT3HjYwnp8sJ6Si5MJaPzNHjlm06TXbPLR23RJZYFKA1XvQoy7HQFcfE00IXRjG8RP"
);

function Checkout({ date, clientSecret, onSuccess }) {
  const stripe = useStripe();
  const elements = useElements();
  const [processing, setProcessing] = useState(false);

  const submit = async () => {
    if (!stripe || !elements) return;
    setProcessing(true);

    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: { return_url: window.location.href },
      redirect: "if_required",
    });

    if (error) {
      alert(error.message);
      setProcessing(false);
      return;
    }

    // Fetch the payment intent from Stripe using clientSecret
    console.log(clientSecret);
    const intentResult = await stripe.retrievePaymentIntent(clientSecret);
    if (intentResult.paymentIntent?.status === "succeeded") {
      await fetch("/api/days/purchase/confirm", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({
          date,
          paymentIntentId: intentResult.paymentIntent.id,
        }),
      });

      onSuccess();
    } else {
      alert("Payment not successful");
    }

    setProcessing(false);
  };

  return (
    <>
      <PaymentElement />
      <Button
        className="w-100 mt-3"
        size="lg"
        disabled={processing}
        onClick={submit}
      >
        {processing ? (
          <>
            <Spinner size="sm" /> Processing…
          </>
        ) : (
          "Pay & Purchase"
        )}
      </Button>
    </>
  );
}


export default function Purchase() {
  const [date, setDate] = useState("");
  const [clientSecret, setClientSecret] = useState(null);
  const [loading, setLoading] = useState(false);

  const startPurchase = async () => {
    if (!date) return;

    setLoading(true);
    try {
      const res = await fetch("/api/days/purchase/start", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({ date }),
      });

      const data = await res.json();
      console.log(data.clientSecret);
      setClientSecret(data.clientSecret);
    } catch (err) {
      console.error(err);
      alert("Failed to start payment");
    }
    setLoading(false);
  };

  return (
    <Container className="mt-5" style={{ maxWidth: 520 }}>
      <Card className="shadow-sm">
        <Card.Body>
          <Card.Title className="fs-3 mb-3">💳 Purchase a Day</Card.Title>

          <Alert variant="info">
            Select a date and complete payment to register it under your name.
          </Alert>

          <Form>
            <Form.Group>
              <Form.Label>Select Date</Form.Label>
              <Form.Control
                type="date"
                value={date}
                onChange={(e) => setDate(e.target.value)}
              />
            </Form.Group>

            <Button
              className="w-100 mt-3"
              size="lg"
              disabled={!date || loading}
              onClick={startPurchase}
            >
              {loading ? (
                <>
                  <Spinner size="sm" /> Starting payment…
                </>
              ) : (
                "Continue to Payment"
              )}
            </Button>
          </Form>

          {clientSecret && (
            <div className="mt-4">
              <hr />
              <Elements stripe={stripePromise} options={{ clientSecret }}>
                <Checkout
                  date={date}
                  clientSecret={clientSecret}
                  onSuccess={() => {
                    alert("Day successfully purchased 🎉");
                    setClientSecret(null);
                    setDate("");
                  }}
                />
              </Elements>
            </div>
          )}
        </Card.Body>
      </Card>
    </Container>
  );
}
